import $ from 'jquery';
import lineHeight from './lineHeight';
import breakpoints, { keys } from './breakpoints';

export function truncateByLines($element) {
  const lh = lineHeight($element);
  const lines = parseInt($element.data('truncateLines')) || 4;

  $element.shave(lh * lines)
}

export function truncateByHeight($element) {
  const $container = $element.children('.truncate-container');
  const maxHeight = $element.height();
  const minHeight = lineHeight($element);

  $container.shave(Math.max(minHeight, maxHeight));
}

export default () => {
  Drupal.behaviors.truncateByHeight = {
    attach: function(context, settings) {
      $('.truncate-by-height', context).once('truncate')
        .wrapInner('<div class="truncate-container">')
        .each((i, node) => {
          truncateByHeight($(node));
        });
    }
  };

  Drupal.behaviors.truncateByLines = {
    attach: function(context, settings) {
      $('.truncate-by-lines', context).once('truncate')
        .each((i, node) => {
          truncateByLines($(node));
        });
    }
  };

  Object.values(breakpoints.min).forEach((mq) => {
    mq.addListener(() => {
      $('.truncate-by-height').each((i, node) => {
        truncateByHeight($(node));
      });

      $('.truncate-by-lines').each((i, node) => {
        truncateByLines($(node));
      });
    })
  });
}
